import { Controller } from "stimulus"
import moment from 'moment'

export default class extends Controller {
  static targets = ['serviceCategory', 'servicesContainer', 'serviceName', 'serviceOptions', 'servicePrice', 'serviceTimeSlot', 'form', 'submitButton', 'subTotal']

  updateServiceSummary() {
    this.updateSubTotal()
    this.serviceNameTarget.innerHTML = this.selectedService?.dataset?.serviceName
    this.servicePriceTarget.innerHTML = this.subTotalTarget.innerHTML
  }

  preventSubmit(event) {
    if (event.key == "Enter") {
      event.preventDefault()
    }
  }

  get selectedService() {
    return this.servicesContainerTarget.querySelector('input[type="radio"]:checked')?.closest('.service-container');
  }

  updateSubTotal() {
    const target = event.currentTarget;
    let selectedService = this.selectedService

    if (selectedService) {
      if (target.classList.contains('time-slot') && target.classList.contains('selected')) {
        selectedService = target
      }

      const selectedCategory = this.serviceCategoryTarget.querySelector('input[type="radio"]:checked')
      const subTotalTargets = document.querySelectorAll('.service-subtotal')

      const price = selectedCategory.value === "master" ? 'servicePricePremium' : 'servicePrice'
      const currentSelectionPrice = document.getElementById('current-selection-price') // for service_options view

      if (currentSelectionPrice) {
        currentSelectionPrice.innerHTML = `&euro;${selectedService.dataset[price]}`
      }

      const checkboxesOptions = Array.from(document.querySelectorAll('.service-container--slim'))

      checkboxesOptions.forEach((item) => {
        const priceOption = item.querySelector('.price')
        priceOption.innerHTML = `&euro;${item.dataset[price]}`
      })

      const selectedCheckboxesOptions = Array.from(document.querySelectorAll('.service-container--slim.selected'))

      const totalPriceOptions = selectedCheckboxesOptions.reduce((sum, checkbox) => sum + parseInt(checkbox.dataset[price]), 0)
      const totalPrice = (parseInt(selectedService.dataset[price]) + parseInt(totalPriceOptions))

      subTotalTargets.forEach(element => {
        element.innerHTML = `&euro;${totalPrice}`

        if (event.currentTarget.hasAttribute('animate-subtotal') && element.offsetParent !== null) { // if visible in the DOM
          element.classList.add('animate--highlight')

          element.addEventListener('animationend', function handler() {
            element.classList.remove('animate--highlight')
            element.removeEventListener('animationend', handler)
          })
        }
      })
    }
  }

  resetSubTotal() {
    document.querySelectorAll('.service-subtotal').forEach(element => {
      element.innerHTML = `&euro;0`
    })
  }

  updateServiceOptionsSummary() {
    const checkboxes = Array.from(document.querySelectorAll('.service-container--slim.selected'))

    const serviceOptionNames = checkboxes.map(checkbox => checkbox.getAttribute('data-service-name')).join(', ')
    this.serviceOptionsTarget.innerHTML = serviceOptionNames
    this.updateSubTotal()
  }

  updateServiceTimeSlot() {
    const formattedTimeSlot = moment(event.currentTarget.dataset.timeSlot).format('MMMM Do [at] HH:mm')
    this.serviceTimeSlotTarget.innerHTML = formattedTimeSlot
  }

  prepare() {
    this.loadingState(true)
  }

  onPostSuccess(event) {
    let [data, status, xhr] = event.detail;
    document.querySelector('#ba-summary').innerHTML = xhr.response
    this.stepsController.jumpToSummaryStep()
    this.loadingState(false)
  }

  onPostError(event) {
    let [data, status, xhr] = event.detail;

    if (xhr.status === 409) {
      if (confirm('Oops! Unfortunately the choosen timeslot is not available anymore. It seems like someone may have been before you. Please choose a different timeslot...')) {
        this.stepsController.reset()
      }
    }

    if (xhr.status === 500) {
      alert('Oh oh! Something went wrong, we are currently fixing this issue! Please refresh and try again in just a bit...')
    }
    this.loadingState(false)
  }

  loadingState(boolean) {
    this.showLoader(boolean)
    this.submitButtonTarget.disabled = boolean
  }

  showLoader(condition) {
    const display = (condition === true ? 'block' : 'none')
    this.submitButtonTarget.querySelector('.loader').style.display = display
  }

  get stepsController() {
    return this.getControllerByIdentifier("widget--steps")
  }

  getControllerByIdentifier(identifier) {
    return this.application.controllers.find(controller => {
      return controller.context.identifier === identifier;
    });
  }
}
